import React, { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import { hot } from 'react-hot-loader/root'
import { AppStore } from 'src/pc/store/AppStore'
import { useWaitModData } from '@hhpack/use-cms'
import { UserInfoHS } from 'src/commons/store/UserStore'
import { GetChannel } from 'src/commons/utils/index'
import {
  activityEntranceHS,
  DWGetActivityConfigInfo,
  activityEntranceGetDetailsHttp,
  activityFinishGetWelfareHttp,
  getActivityStatusByNoStatus,
} from 'src/commons/store/GameStore'
import { message } from 'antd'
import styled from '@emotion/styled'
import entryImg from 'src/pc/assets/images/receive-welfare/entry.png'

const ACTIVITY_NO = 'AT5776001626880410075'
const RedEnvelopesEntry: React.FC = () => {
  const visible = useMemo(() => {
    return (
      AppStore['activity-23-8-11'].userActivityStatus.signUpEntry ||
      AppStore['activity-23-8-11'].userActivityStatus.claimEntry
    )
  }, [
    AppStore['activity-23-8-11'].userActivityStatus.signUpEntry,
    AppStore['activity-23-8-11'].userActivityStatus.claimEntry,
  ])

  const clickEntryEvent = async () => {
    try {
      await getUserHaveGame()
      window.sensorsdataReportParams?.('MotivationGames_Entry_Click', { position: 'HomePage' })
      const userInfo = UserInfoHS.SuccessResult
      if (!userInfo?.id) {
        return null
      }
      AppStore['activity-23-8-11'].type = 'home'
      const res = await activityEntranceGetDetailsHttp.Execute({
        activityNo: ACTIVITY_NO,
        userGameLibrary: AppStore['activity-23-8-11'].userHasGameKeys,
        entranceType: 1,
      })
      AppStore['activity-23-8-11']['1'] = res
      // 已完成任务直接打开抽奖弹窗
      if (res.activityTaskStatus === 1 || res.activityTaskStatus === 2) {
        AppStore['activity-23-8-11'].luckyModalVisible = true
        window.sensorsdataReportParams?.('MotivationGames_PrizesPop_View', {
          position: 'HomePage',
          game_name:
            AppStore['activity-23-8-11'].userHasGames?.find(
              d => d.key === AppStore['activity-23-8-11']['1']?.activityWebGameId,
            )?.name || '',
        })
        return
      }
      AppStore['activity-23-8-11'].applyModalVisible = true
      window.sensorsdataReportParams?.('MotivationGames_SignUpPop_View', {
        position: 'HomePage',
        game_name:
          AppStore['activity-23-8-11'].userHasGames?.find(
            d => d.key === AppStore['activity-23-8-11']['1']?.activityWebGameId,
          )?.name || '',
      })
    } catch (error) {
      message.warn((error as any).message)
    }
  }

  useEffect(() => {
    if (visible) {
      window.sensorsdataReportParams?.('MotivationGames_Entry_View', { position: 'HomePage' })
    }
  }, [visible])

  if (!visible) {
    return null
  }

  return (
    <StyledRedEnvelopEntry onClick={() => clickEntryEvent()}>
      <img src={entryImg} />
      <StyledEntryText>领会员</StyledEntryText>
    </StyledRedEnvelopEntry>
  )
}

/** 获取用户拥有的免费游戏Key值集合 */
export const getUserHaveGame = async () => {
  try {
    const simpleshqPageGameConfig = await useWaitModData<TPageGame>('simpleshq_pagegame_config')
    if (!simpleshqPageGameConfig) {
      return []
    }
    const userInfo = UserInfoHS.SuccessResult
    if (!userInfo?.id) {
      return []
    }
    const removePageGameIds = getLocalStoreDataByUserId('removePageGameIds')
    if (!removePageGameIds || removePageGameIds.length === 0) {
      const keys = simpleshqPageGameConfig?.map(d => d.key)
      AppStore['activity-23-8-11'].userHasGames = simpleshqPageGameConfig
      AppStore['activity-23-8-11'].userHasGameKeys = keys
      return keys
    }
    const temp = simpleshqPageGameConfig?.filter(d => !removePageGameIds?.includes(d.key))
    const keys = temp?.map(d => d.key)
    AppStore['activity-23-8-11'].userHasGames = temp
    AppStore['activity-23-8-11'].userHasGameKeys = keys
    return keys
  } catch (error) {
    return []
  }
}

export const loadWelfareEntry = async () => {
  const token = localStorage.getItem('php-token')
  if (!token) {
    return
  }
  const userInfo = await UserInfoHS.Execute({ token })
  try {
    const Query = new URLSearchParams(window.location.search.substr(1, window.location.search.length))
    const deviceUid = Query.get('mid') || localStorage.getItem('mid') || ''
    const keys = await getUserHaveGame()
    const { claimEntry, signUpEntry, claimed, signUp, hasLottery } = await activityEntranceHS.Execute({
      activityNo: ACTIVITY_NO,
      deviceId: deviceUid,
      userId: userInfo?.id,
      userGameLibrary: keys,
    })
    AppStore['activity-23-8-11'].deviceId = deviceUid
    AppStore['activity-23-8-11'].userActivityStatus = {
      claimEntry,
      signUpEntry,
      claimed,
      signUp,
      hasLottery,
    }
    loadWelfareConfig()
    reloadWelfareInfoByEntryType(1)
    reloadWelfareInfoByEntryType(2)
    reloadWelfareInfoByEntryType(3)
  } catch (error) {
    AppStore['activity-23-8-11'].userActivityStatus = {
      claimEntry: false,
      signUpEntry: false,
      claimed: false,
      signUp: false,
      hasLottery: false,
    }
    console.warn((error as any).message)
  }
}

/** 获取活动配置 */
export const loadWelfareConfig = async () => {
  const cfg = await DWGetActivityConfigInfo.Execute({ activityNo: ACTIVITY_NO })
  AppStore.activityConfigWithNo[ACTIVITY_NO] = cfg
  return cfg
}

export const getLocalStoreDataByUserId = (key: string): any[] | null => {
  const userInfo = UserInfoHS.SuccessResult
  if (!userInfo?.id) {
    return null
  }
  const datastr = localStorage.getItem(key)
  if (datastr && userInfo?.id) {
    return JSON.parse(datastr)[userInfo.id]
  }
  return null
}
/** 倒计时完成，静默发奖*/
export const receiveWelfareFun = async (openModal?: boolean) => {
  const userInfo = UserInfoHS.SuccessResult
  if (!userInfo?.id) {
    return
  }
  try {
    await getActivityStatusByNoStatus.Execute({ activityNo: ACTIVITY_NO })
  } catch (error) {
    return message.warn('当前参与人数过多，活动数量已达上限')
  }

  const isHome = AppStore['activity-23-8-11'].type === 'home'
  const isSpeed = AppStore['activity-23-8-11'].type === 'speed'
  if (!openModal) {
    await activityFinishGetWelfareHttp.Execute({
      activityNo: ACTIVITY_NO,
      entranceType: isHome ? 1 : isSpeed ? 2 : 3,
      userId: userInfo?.id,
      activityTheme: [AppStore['activity-23-8-11'].downCountGameKey],
      identity: `${
        isHome
          ? ''
          : isSpeed
          ? AppStore['activity-23-8-11']['2']?.prizeWelfares?.[0]?.productId
          : AppStore['activity-23-8-11']['3']?.prizeWelfares?.[0]?.productId
      }`,
      channel: GetChannel(),
    })
    reloadWelfareInfoByEntryType(isHome ? 1 : isSpeed ? 2 : 3)
  }
  if (isHome && openModal) {
    AppStore['activity-23-8-11'].luckyModalVisible = true
    window.sensorsdataReportParams?.('MotivationGames_PrizesPop_View', {
      position: 'HomePage',
      game_name:
        AppStore['activity-23-8-11'].userHasGames?.find(
          d => d.key === AppStore['activity-23-8-11']['1']?.activityWebGameId,
        )?.name || '',
    })
    return
  }
  if (openModal) {
    AppStore['activity-23-8-11'].receivedSuccessVisible = true
    window.sensorsdataReportParams?.('MotivationGames_PrizesPop_View', {
      position: isSpeed ? 'Mygame1' : 'Mygame2',
      game_name:
        AppStore['activity-23-8-11'].userHasGames?.find(
          d => d.key === AppStore['activity-23-8-11'][isSpeed ? '2' : '3']?.activityWebGameId,
        )?.name || '',
    })
  }
}

export const reloadWelfareInfoByEntryType = async (entranceType: 1 | 2 | 3) => {
  const userInfo = UserInfoHS.SuccessResult
  if (!userInfo?.id) {
    return null
  }
  const keys = await getUserHaveGame()
  const res = await activityEntranceGetDetailsHttp.Execute({
    activityNo: ACTIVITY_NO,
    userGameLibrary: keys,
    entranceType: entranceType,
  })
  AppStore['activity-23-8-11'][entranceType === 1 ? '1' : entranceType === 2 ? '2' : '3'] = res
}

const StyledEntryText = styled.div`
  font-size: 12px;
  color: #b0b0b0;
  text-align: center;
`
const StyledRedEnvelopEntry = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    position: relative;
    width: 42px;
    height: 32px;
    cursor: pointer;
  }
  &:hover {
    ${StyledEntryText} {
      color: #ffffff;
    }
    img {
      animation: jump 1.5s ease-in-out;
    }
  }
  @keyframes swing-animation {
    0% {
      transform: rotate(0deg);
    }
    45% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(10deg);
    }
    60% {
      transform: rotate(-8deg);
    }
    70% {
      transform: rotate(6deg);
    }
    80% {
      transform: rotate(-4deg);
    }
    90% {
      transform: rotate(2deg);
    }
    95% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
`

export default hot(observer(RedEnvelopesEntry))
